import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import TrendUpIconSvg from './TrendUpIconSvg'

const TrendUpIcon = (props: IconProps): ReactElement => {
    const { color, height = '1em', width = '1em' } = props
    return (
        <Icon
            component={() => (
                <TrendUpIconSvg color={color} height={height} width={width} />
            )}
            {...props}
        />
    )
}

export default TrendUpIcon
